import { STATUS_BOOKING } from '../../../constants/commondata';

export const GSN_OFFER_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  SENT: 'sent',
};

export const GSN_ROLE = {
  HOME: 'home',
  PROVIDER: 'provider',
};

export const isEnableFarmOutHydra = (selectedFleet) => {
  return (
    selectedFleet?.affiliateNetwork?.enable && selectedFleet?.farmOut?.isActive
  );
};

export const isEnableFarmInHydra = (selectedFleet) => {
  return (
    selectedFleet?.affiliateNetwork?.enable && selectedFleet?.farmIn?.isActive
  );
};

export const checkFarmOutHydra = (booking) => {
  return booking?.dispatch_type === 9 || booking?.dispatchType === 9;
};

export const checkFarmInHydra = (booking) => {
  return booking?.externalInfo?.gsnRole === GSN_ROLE.PROVIDER;
};

// đã assign nhưng chưa được accept
export const checkIsFarmOutAllocatedStatus = (booking) => {
  return (
    checkFarmOutHydra(booking) &&
    booking?.externalInfo?.gsnOfferStatus === GSN_OFFER_STATUS.SENT
  );
};

// đã assign và đã accept nhưng chưa assign driver (status pending bên phía farmIn fleet)
export const checkIsFarmOutAcceptedStatus = (booking) => {
  return (
    checkFarmOutHydra(booking) &&
    booking?.externalInfo?.gsnOfferStatus === GSN_OFFER_STATUS.ACCEPTED &&
    [STATUS_BOOKING.pending, STATUS_BOOKING.pre].includes(booking?.status)
  );
};

export const getProviderHydraInfo = (booking) => {
  if (
    booking?.externalInfo?.gsnRole !== GSN_ROLE.HOME ||
    !booking?.externalInfo?.gsnProviderFleetId
  )
    return null;
  return {
    providerInfo: {
      fleetName: booking?.externalInfo?.gsnProviderFleetName,
      fleetId: booking?.externalInfo?.gsnProviderFleetId,
      zoneId: booking.externalInfo.gsnProviderZoneId,
      carTypeId: booking?.externalInfo?.gsnProviderVehicleTypeId,
      packageRateId: booking?.externalInfo?.gsnProviderPackageRateId,
      gjPrice: booking?.externalInfo?.gsnPricingCache?.gjPrice,
      currency: booking.externalInfo.gsnPricingCache?.currencyISO,
      fleetLogo: booking.externalInfo.gsnProviderFleetLogo,
    },
    gsnAffiliateCarTypeId: booking.externalInfo.gsnAffiliateCarTypeId,
  };
};

export const getAffiliateCarTypeInfo = (
  hydraSetting,
  gsnAffiliateCarTypeId,
) => {
  return hydraSetting?.affiliateCarType?.find(
    (item) => item._id === gsnAffiliateCarTypeId,
  );
};

export const getETAHydraFareOutSide = ({ price = 0, currency, fleetId }) => {
  return {
    basicFare: price,
    etaFare: price,
    currencyISO: currency,
    totalWithoutPromo: price,
    unroundedTotalAmt: price,
    subTotal: price,
    markupEstimateAmount: price,
    fleetPrice: price,
    // gjPrice: price,
    airportFee: 0,
    meetDriverFee: 0,
    rushHourFee: 0,
    techFee: 0,
    bookingFee: 0,
    tollFee: 0,
    parkingFee: 0,
    gasFee: 0,
    tax: 0,
    tip: 0,
    minFare: 0,
    normalFare: true,
    route: '',
    routeId: '',
    reverseRoute: false,
    min: false,
    isMinimumTotal: false,
    otherFees: 0,
    promoAmount: 0,
    bookingFeeActive: false,
    serviceFee: 0,
    serviceTax: 0,
    typeRate: 0,
    extraDistanceFee: 0,
    extraDurationFee: 0,
    taxValue: 0,
    tipValue: 0,
    dynamicSurcharge: 0,
    surchargeParameter: 0,
    dynamicFare: 0,
    dynamicFactor: 0,
    dynamicType: 'factor',
    shortTrip: false,
    taxSetting: 0,
    addOnPrice: 0,
    markupDifference: 0,
    creditTransactionFee: 0,
    creditTransactionFeeAmount: 0,
    creditTransactionFeePercent: 0,
    promoCode: '',
    priceAdjustable: {
      emoji: false,
      enable: false,
      minimumPercent: 0,
      maximumPercent: 0,
    },
    validPriceAdjustable: true,
    actualFare: false,
    markupEstimate: 0,
    fleetMarkup: 0,
    fleetCommissionFromFleetServiceFee: 0,
    driverCommissionFromFleetServiceFee: 0,
    rateType: 'regular',
    rateId: '',
    rateByDropOffZone: true,
    extraWaitTime: 0,
    extraWaitFee: 0,
    waitFeeInJourney: 0,
    moveFeeInJourney: 0,
    speedThreshold: 0,
    perTime: 0,
    perDistance: 0,
    startingFee: 0,
    mode: 'timeAndMileage',
    fleetId: fleetId,
    supplierEarningType: 'default',
    editedSupplierEarning: 0,
    originalSupplierEarning: 0,
    driverEarningType: 'default',
    editedDriverEarning: 0,
    originalDriverEarning: 0,
    totalPayout: 0,
    feePayToSupplier: 0,
    apiVersion: '',
    isFeePerSeatActive: false,
    cachedLocation: false,
    meetAndGreetFee: 0,
    markUpByPercentage: 0,
    addonServices: [],
    addOnTax: 0,
    totalAddonFee: 0,
  };
};

export const sortProvidersByGjP = (data) => {
  if (!Array.isArray(data)) return [];

  return data.map((item) => ({
    ...item,
    providers: Array.isArray(item?.providers)
      ? [...item.providers].sort(
          (a, b) => (a?.gjPrice ?? 0) - (b?.gjPrice ?? 0),
        )
      : [],
  }));
};
